import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';

import {
  ContextColorProvider,
  NavBar,
  HeadingDisplay,
  HelperViewStatus,
  HelperViewContextual,
  InfiniteScroll
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { PortabilityCard } from './components/PortabilityCard';
import { PortabilityRequestsLoader } from './components/PortabilityRequestsLoader';
import {
  getPortabilityRequests,
  PortabilityRequest
} from '@/modules/trade/services/portability';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortabilityRequests',
  setup(__props) {

const isLoading = ref(true);
const hasError = ref(false);
const page = ref(1);
const itemsPerPage = ref(10);
const hasMorePages = ref(false);
const portabilityRequests = ref<PortabilityRequest[] | null>(null);

const hasPortabilityRequests = computed(() => {
  return portabilityRequests.value && portabilityRequests.value.length > 0;
});

const handleFetchMoreRequests = async () => {
  if (hasMorePages.value) {
    page.value++;
    await fetchPortabilityRequestsData();
  }
};

const fetchPortabilityRequestsData = async () => {
  try {
    isLoading.value = true;
    hasError.value = false;

    const response = await getPortabilityRequests(
      itemsPerPage.value,
      page.value
    );

    portabilityRequests.value = [
      ...(portabilityRequests.value || []),
      ...response.items
    ];
    page.value = response.pagination.page;
    hasMorePages.value = response.pagination.hasMore;
  } catch (e) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  await fetchPortabilityRequestsData();
});

return { __sfc: true,isLoading, hasError, page, itemsPerPage, hasMorePages, portabilityRequests, hasPortabilityRequests, handleFetchMoreRequests, fetchPortabilityRequestsData, ContextColorProvider, NavBar, HeadingDisplay, HelperViewStatus, HelperViewContextual, InfiniteScroll, BackButton, PortabilityCard, PortabilityRequestsLoader }
}

})